import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="uc-footer">
      <div className="container pb-48">
        <div className="row">
          <div className="col-7 col-md-3 col-xl-2 mb-32">
            <a href="/">
              <img
                src="https://kit-digital-uc-prod.s3.amazonaws.com/assets/logo-uc-blanco.svg"
                alt="Pontificia Universidad Católica de Chile"
                className="img-fluid"
              />
            </a>
          </div>
          <div className="col-lg-8 offset-lg-1">
            {/* Título del sitio, igual que el header y el <title> (Checklist de
                Contenido DINV, rev. 2026-07-20). */}
            <div className="h2 color-white text-font--serif mt-28">
              Plataforma de postulación Avanza UC
            </div>
            <div className="uc-subtitle color-white mb-16"></div>
            <div className="mb-32">
              Dirección de Investigación - Vicerrectoría de Investigación y
              Postgrado
            </div>
            <div>
              Para consultas sobre bases:{' '}
              <a href="mailto:avanza.uc@uc.cl">avanza.uc@uc.cl</a>
            </div>
            <div>
              Para soporte técnico:{' '}
              <a href="mailto:soporte@spotmind.cl">soporte@spotmind.cl</a>
            </div>
            <div className="mt-16">
              <a
                href="https://avanza.uc.cl"
                target="_blank"
                rel="noopener noreferrer"
              >
                Sitio del proyecto: avanza.uc.cl{' '}
                <i className="uc-icon icon-size--sm">open_in_new</i>
              </a>
            </div>
            <div>
              <a
                href="https://protecciondedatos.uc.cl/politicas/profesores-y-funcionarios-postdoc/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Políticas de privacidad{' '}
                <i className="uc-icon icon-size--sm">open_in_new</i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
